import script from "./AboutView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutView.vue?vue&type=script&setup=true&lang=ts"

import "./AboutView.vue?vue&type=style&index=0&id=6c8fc450&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c8fc450"]])

export default __exports__